import React from 'react';
import { m } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { BASE_OFFER_CHECKOUT_URL, PREMIUM_OFFER_CHECKOUT_URL } from '../utils/checkout';
export function FinalCTA() {
  return <section className="bg-bg-secondary py-10 sm:py-14" data-id="element-65" data-mp="3msqpa8651ym9">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-66" data-mp="3rsv7c2mp31el">
        <h2 className="font-heading text-3xl font-bold uppercase leading-tight text-white sm:text-4xl" data-id="element-67" data-mp="3rr0kgirv4z7v">
          La decisión es tuya.
        </h2>
        <div className="mx-auto mt-6 max-w-2xl space-y-3 text-left text-base leading-relaxed text-muted sm:text-center" data-id="element-68" data-mp="3hv6yk8s97tdf">
          <p data-id="element-69" data-mp="33vxw0bwz0xrx">
            Puedes seguir como hasta ahora. Preparando entrenamientos desde cero cada semana, improvisando
            cuando el plan falla y llegando al pabellón con la duda de si lo que vas a hacer es lo correcto
            para tu equipo.
          </p>
          <p data-id="element-70" data-mp="172duy98u37sz">O puedes llegar al martes con todo listo. Con la sesión elegida, el objetivo claro y la consigna exacta en el bolsillo.</p>
          <p className="font-semibold text-white" data-id="element-71" data-mp="q7c4uqmra69g">180 sesiones. 6 tomos. 5 bonos. 14 días de garantía.</p>
          <p className="text-orange" data-id="element-72" data-mp="l8r0qg4dv2fq">El precio de una cena. El valor de una temporada entera.</p>
        </div>

        <div className="mt-8 grid gap-5 sm:grid-cols-2" data-id="element-73" data-mp="z05o0z5bppsl">
          <m.a href={BASE_OFFER_CHECKOUT_URL} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4
        }} className="group flex flex-col items-center gap-3 rounded-2xl border border-orange/30 bg-bg-primary p-6 text-left transition-colors hover:border-orange/60" data-id="element-74" data-mp="uz3m2ak0uzmx">
            <span className="font-heading text-sm font-semibold uppercase tracking-wide text-muted" data-id="element-75" data-mp="babb6hl0818c">
              🏀 Oferta Base
            </span>
            <span className="font-heading text-3xl font-bold text-white" data-id="element-76" data-mp="1rrfkd4c69ct4">17,90€</span>
            <span className="mt-2 inline-flex items-center gap-2 rounded-xl bg-orange px-5 py-2.5 text-sm font-semibold uppercase text-white transition-colors group-hover:bg-orange-hover" data-id="element-77" data-mp="1mq9ncubhb3ds">
              Empezar ahora
              <ArrowRightIcon size={16} className="transition-transform group-hover:translate-x-1" data-id="element-78" data-mp="pe15eagr0udi" />
            </span>
            <span className="text-[11px] text-muted" data-id="element-79" data-mp="ycmqac9p0lhg">
              💳 Pago único · ⚡ Acceso inmediato · 🛡️ Garantía 14 días
            </span>
          </m.a>

          <m.a href={PREMIUM_OFFER_CHECKOUT_URL} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: 0.08
        }} className="group flex flex-col items-center gap-3 rounded-2xl border border-gold/30 bg-bg-primary p-6 text-left transition-colors hover:border-gold/60" data-id="element-80" data-mp="1kj1r1idcxi8">
            <span className="font-heading text-sm font-semibold uppercase tracking-wide text-muted" data-id="element-81" data-mp="3j33w1mt1tgu3">
              🏆 Pack Premium
            </span>
            <span className="font-heading text-3xl font-bold text-white" data-id="element-82" data-mp="3bi9uubpm4dav">23,90€</span>
            <span className="mt-2 inline-flex items-center gap-2 rounded-xl bg-gold px-5 py-2.5 text-sm font-semibold uppercase text-bg-primary transition-colors group-hover:bg-gold/90" data-id="element-83" data-mp="36ljd7jy5t9nc">
              Quiero el pack completo
              <ArrowRightIcon size={16} className="transition-transform group-hover:translate-x-1" data-id="element-84" data-mp="2xja7r8hr06gt" />
            </span>
            <span className="text-[11px] text-muted" data-id="element-85" data-mp="2smtddwjygvva">
              💳 Pago único · ⚡ Acceso inmediato · 🛡️ Garantía 14 días
            </span>
          </m.a>
        </div>
      </div>
    </section>;
}